import { inject, Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { LocateRequest } from 'app/core/map/search-bar/autocomplete.model';
import { MunicipalityDetails } from 'app/core/map/search-bar/site-finder-search.model';
import { MunicipalityZone } from 'app/core/zone-search/municipality-zone.model';
import { Position } from 'app/shared/ll/models/geometry';
import { NotificationsService } from 'app/shared/toast';
import { BehaviorSubject, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ViewRequest } from '../ll/models/map';
import { BillingDetails } from './subscriptions.model';


@Injectable({
    providedIn: 'root',
})
export class EventsService {

    private ns = inject(NotificationsService);

    // my-autoprop/my-account/formSaved
    formSavedSubject: Subject<void> = new Subject();

    formSavedEffect = createEffect(
        () => {
            let lastId: string | undefined;
            return this.formSavedSubject.pipe(
                tap(() => {
                    if (lastId) {
                        this.ns.remove(lastId);
                    }
                    lastId = this.ns.success('Automatically Saved', 'Your changes were saved!').id;
                })
            );
        },
        { dispatch: false }
    );

    // properties-table/property-save-in-collection
    propertySavedToCollection = new Subject<boolean>();

    // header/property-loading
    propertyLoading = new BehaviorSubject(false);

    layersLoading = new BehaviorSubject(false);

    // dashboard/map.component && properties-table-window
    centerToProperty = new Subject<Position>();

    // yodaSearch zoom to center of found parcels
    centerToBounds = new Subject<{ bounds: Position[]}>();

    locate = new Subject<LocateRequest>();

    showMovingMarker = new BehaviorSubject<{ position: Position; adjusting: boolean } | null>(null);

    movingMarkerMoved = new Subject<Position>();

    billingDetails = new BehaviorSubject<BillingDetails | null>(null);

    municipalities = new BehaviorSubject<MunicipalityZone[] | null>(null);

    sfMunicipalities = new BehaviorSubject<MunicipalityDetails[] | null>(null);

    setView = new Subject<ViewRequest>();

    fitBounds = new Subject<Position[]>();
}
